import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function Card({ children, className, style }: CardProps) {
  return (
    <div
      style={style}
      className={cn('rounded-2xl border border-hairline bg-glass p-4 shadow-lg', className)}
    >
      {children}
    </div>
  );
}
